/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { EventType } from '../models/event-type';

/**
 * Event Update DTO
 */
export interface EventUpdate {

  /**
   * Code
   */
  code?: string | null;
  date?: string | null;
  description?: string | null;
  location?: string | null;

  /**
   * Name
   */
  name: string;
  type?: EventType;
}

export class EventUpdate {
  code?: string | null;
  date?: string | null;
  description?: string | null;
  location?: string | null;
  name: string;
  type?: EventType;

  constructor(value: EventUpdate) {
    this.code = value?.code;
    this.date = value?.date;
    this.description = value?.description;
    this.location = value?.location;
    this.name = value.name;
    this.type = value?.type ? Object.entries(Object.values(EventType)).flatMap((x) => x).find(x => x === value.type) as EventType : undefined;
  }
}
